import clsx from "clsx";
import { UploadInputDisplaySize } from "../../FileUpload/UploadInputDisplay/UploadInputDisplay.types";
import { ImageUploadPlaceholderRoot } from "./ImageUploadPlacholder.styles";

export interface ImageUploadPlaceholderProps {
    className?: string;
    style?: React.CSSProperties;
    size: UploadInputDisplaySize;
}

const ImageUploadPlaceholder = ({ className, ...rest }: ImageUploadPlaceholderProps) => {
    return <ImageUploadPlaceholderRoot className={clsx("image-upload-placeholder", className)} {...rest} />;
};

export default ImageUploadPlaceholder;
